export default __webpack_public_path__ + "static/media/splash.fb54d590.jpg";